import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  // Overrides the AST Console Revamp mockup's `.grid-4` stat-tile grid
  // (originally one bordered/rounded tile per field) — per explicit request,
  // every field now lives in a single shared Card (see index.tsx) instead.
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: 16,
  },
};

export default styles;
